export default __webpack_public_path__ + "static/media/filter.793de0d6.svg";